import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getCampaignOperation',
})
export class GetCampaignOperationPipe implements PipeTransform {
  transform(campaignParts: any[], campaignId: string): unknown {
    const matchingRecallCampaignParts = campaignParts.find((item) => item.recallCampaignId === campaignId);

    if (!Array.isArray(matchingRecallCampaignParts.recallCampaignParts)) {
      return []; // No parts found
    } else {
      return matchingRecallCampaignParts.recallCampaignParts;
    }
  }
}
